import { Controller } from '@hotwired/stimulus';
import Vue from 'vue';

export default class extends Controller {
  static targets = ['template'];
  static values = {
    shopBarcode: Object,
    typeof: String,
    rotate: Boolean,
    calc: Boolean,
  };

  connect() {
    const el = this.templateTarget;
    const { shop_branch_id, shop_card_id, shop_barcode_id, shop_barcode_icon } =
      this.shopBarcodeValue;

    this.vm = new Vue({
      el,
      data: {
        shop_branch_id,
        shop_card_id,
        shop_barcode_id,
        shop_barcode_icon,
      },
      methods: {
        onChangeIcon: function (event) {
          const fr = new FileReader();
          const file = event.target.files[0];
          fr.readAsDataURL(file);
          fr.onload = (e) => {
            this.shop_barcode_icon = e.target.result;
          };
        },
      },
    });

    // QRコード有効期限設定のON/OFF

    // 有効期限のセレクトボックス変更時、datetimeセレクトボックスの表示/非表示及びdisabled設定切り替え
    const expireToggle = document.getElementById('expire_toggle');
    if (expireToggle) {
      this.toggleExpireFields = () => {
        const expired = expireToggle.value === 'true';
        document.querySelectorAll('.expire_date_field').forEach((field) => {
          field.classList.toggle('hidden', !expired);
        });
        if (!expired) {
          document
            .querySelectorAll('[id^=shop_barcode_expire_at]')
            .forEach((field) => {
              field.selectedIndex = 0;
            });
        }
      };
      expireToggle.addEventListener('change', this.toggleExpireFields);
      this.toggleExpireFields();
    }
    this.expireToggle = expireToggle;

    // 「位置情報チェック」の有効/無効で距離の表示/非表示を切り替える
    const gpsRadios = document.querySelectorAll('.js-toggleDisplayDistanceBox');
    if (gpsRadios.length > 0) {
      this.toggleDistanceBox = () => {
        const checked = document.querySelector(
          '.js-toggleDisplayDistanceBox:checked',
        );
        document.querySelectorAll('.distance_box').forEach((box) => {
          box.classList.toggle('active', checked?.value === 'true');
        });
      };
      gpsRadios.forEach((radio) => {
        radio.addEventListener('change', this.toggleDistanceBox);
      });
      this.toggleDistanceBox();
    }
    this.gpsRadios = gpsRadios;

    // QRコードの種類によって設定項目の表示を切り分ける
    const description = document.getElementById('typeof_qr_description');
    if (description) {
      let typeofQr = this.typeofValue;
      if (!typeofQr) {
        if (this.calcValue) {
          typeofQr = 'app_calc';
        } else if (this.rotateValue) {
          typeofQr = 'app_fix';
        }
      }

      let str;
      if (typeofQr === 'app_fix') {
        // 店舗App用
        str =
          '店舗アプリ用のQRコードを作成します。付与するスタンプ数は設定された数に固定されます。';
        this.switchFieldGroup('hide', 'issue');
      } else if (typeofQr === 'app_calc') {
        // 店舗App用
        str =
          '店舗アプリ用のQRコードを作成します。付与するスタンプ数を店舗アプリで都度入力します。';
        this.switchFieldGroup('hide', 'stamps');
        this.switchFieldGroup('hide', 'issue');
        this.switchFieldGroup('show', 'yen_per_stamp');
      } else if (typeofQr === 'print_default') {
        // 印刷用
        str = '印刷用のQRコードを作成します。';
      }
      // 説明挿入
      if (str) {
        description.textContent = str;
      }
    }
  }

  switchFieldGroup(action, name) {
    const field = document.getElementById(`shop_barcode_${name}`);
    const group = field?.closest('.form-group');
    if (!group) return;
    group.style.display = action === 'show' ? '' : 'none';
  }

  // メモリリーク防止のため、Vueインスタンスとイベントリスナーを破棄
  disconnect() {
    this.vm?.$destroy();

    if (this.expireToggle && this.toggleExpireFields) {
      this.expireToggle.removeEventListener('change', this.toggleExpireFields);
    }

    if (this.gpsRadios && this.toggleDistanceBox) {
      this.gpsRadios.forEach((radio) => {
        radio.removeEventListener('change', this.toggleDistanceBox);
      });
    }
  }
}
